import { render, staticRenderFns } from "./SignUpStepThree.vue?vue&type=template&id=54980c48"
import script from "./SignUpStepThree.vue?vue&type=script&lang=js"
export * from "./SignUpStepThree.vue?vue&type=script&lang=js"
import style0 from "./SignUpStepThree.vue?vue&type=style&index=0&id=54980c48&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports